import { useEffect,useState } from "react";
import { TextInput } from "src/Components";

export const CriterionValueInput=({ name,value,onChange,allowNegative=true }: {
  name: string;
  value: number|null;
  onChange: (value: number|null) => void;
  allowNegative?: boolean;
}) => {
  const toDisplayValue=(numberValue: number|null) => numberValue===null? "":numberValue<0? `${Math.abs(numberValue)}-`:numberValue.toString();
  const toNumberValue=(rawValue: string) => {
    const negative=rawValue.startsWith("-")||rawValue.endsWith("-");
    const unsigned=rawValue.replace(/-/g,"");
    if(unsigned===""||unsigned===".")
      return null;
    const numberValue=Number(unsigned);
    return Number.isFinite(numberValue)? negative? -numberValue:numberValue:null;
  };
  const [text,setText]=useState(toDisplayValue(value));
  const [isFocused,setIsFocused]=useState(false);
  useEffect(() => {
    const externalText=toDisplayValue(value);
    if(isFocused&&toNumberValue(text)===value)
      return;
    if(text!==externalText)
      setText(externalText);
  },[isFocused,text,value]);
  const change=(_: string,rawValue: string) => {
    const normalized=rawValue
      .replace(/[۰-۹]/g,(digit) => String("۰۱۲۳۴۵۶۷۸۹".indexOf(digit)))
      .replace(/[٠-٩]/g,(digit) => String("٠١٢٣٤٥٦٧٨٩".indexOf(digit)))
      .replace(/[٫،,]/g,".");
    const unsigned=normalized.replace(/-/g,"");
    if((!allowNegative&&normalized.includes("-"))||(normalized.match(/-/g)?.length||0)>1||!/^\d*(?:\.\d*)?$/.test(unsigned))
      return;
    setText(normalized);
    onChange(toNumberValue(normalized));
  };
  return <div dir="ltr">
    <TextInput
      name={name}
      label="مقدار"
      value={text}
      onChange={change}
      direction="ltr"
      onFocus={() => setIsFocused(true)}
      onBlur={() => {
        setIsFocused(false);
        setText(toDisplayValue(toNumberValue(text)));
      }}
      classname="!text-right"
    />
  </div>;
};
